module.exports = __webpack_public_path__ + "img/icon-score7.9b4dda62.svg";